module.exports = function sqrt(arg) {
  //  discuss at: https://locutus.io/php/sqrt/
  // original by: Onno Marsman (https://twitter.com/onnomarsman)
  //   example 1: sqrt(8723321.4)
  //   returns 1: 2953.5269424875746

  return Math.sqrt(arg)
}
